import { useMemo } from 'react';
import { getProductsAndAddons } from '../../../utils';
import { useCurrency } from '../context';

export function useSubtotal(products) {
	const [currency] = useCurrency();

	return useMemo(() => {
		let regularTotal = 0;
		let saleTotal = 0;
		for (const product of getProductsAndAddons(products)) {
			const regularPrice = product.price;
			const salePrice = product.new_price
				? parseFloat(product.new_price)
				: parseFloat(product.sale_price || product.price);
			const qty = parseInt(product.quantity ?? 1);
			regularTotal += (isNaN(regularPrice) ? 0 : regularPrice) * qty;
			saleTotal += (isNaN(salePrice) ? 0 : salePrice) * qty;
		}

		return { regularTotal, saleTotal };
	}, [products, currency]);
}
